import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import {AmenityGroupType} from "@CheckOrder/features/amenities/types/AmenityGroup.type";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useHasPreviouslySelectedAmenitiesFromThisGroup(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType) {
    const {
        singleSelectedAmenities: previouslySelectedSingleAmenities,
        returnSelectedAmenities: previouslySelectedReturnAmenities,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const hasSelectedAmenityFromThisGroup = (
        selectedAmenities: Record<string, CountAmenitySelectedType>,
        amenityGroup: AmenityGroupType | null
    ) => (
        amenityGroup?.amenities.some((amenity) => (
            !!selectedAmenities[amenity.key]
        ))
    )

    return (
        hasSelectedAmenityFromThisGroup(previouslySelectedSingleAmenities || {}, pairedAmenityGroups.singleGroup)
        || hasSelectedAmenityFromThisGroup(previouslySelectedReturnAmenities || {}, pairedAmenityGroups.returnGroup)
    )
}